import { SEMESTERS__REQUESTED__SUCCEEDED } from "../constants/actionTypes";

import _ from 'lodash';

const INITIAL_STATE = {},
    id = iteratee => {
        return iteratee.id;
    }
;

export default function semesters(state = INITIAL_STATE, action) {
    switch (action.type) {

        case SEMESTERS__REQUESTED__SUCCEEDED: {
            const { semesters } = action.payload;

            return {
                ..._.mapKeys(semesters.entities, id)
            };
        }

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/semestersReducer.js
 **/